import { createSlice, PayloadAction, SliceCaseReducers } from '@reduxjs/toolkit';
import _ from 'lodash';
import { RootState } from '../../@types/RootState';

export type NavBarData = {
  label: string;
  panel?: string | null;
  isFree?: boolean;
};

const initialState: NavBarData | null = null;

const slice = createSlice<NavBarData | null, SliceCaseReducers<NavBarData>>({
  name: 'navBar.data',
  initialState,
  reducers: {
    SET_NAVBAR_STATE: (state, action: PayloadAction<Partial<NavBarData>>) => {
      return _.merge({}, state, action.payload);
    },
  },
});

export const { SET_NAVBAR_STATE } = slice.actions;

export const selectorNavBarData = (state: RootState) => {
  return state.navBar.data;
};

export default slice.reducer;
